import { render } from "./ChartsLinkConfiger.vue?vue&type=template&id=04cf5640&scoped=true"
import script from "./ChartsLinkConfiger.vue?vue&type=script&lang=js"
export * from "./ChartsLinkConfiger.vue?vue&type=script&lang=js"

import "./ChartsLinkConfiger.vue?vue&type=style&index=0&id=04cf5640&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04cf5640"]])

export default __exports__